import { render, staticRenderFns } from "./title-cop.vue?vue&type=template&id=1fc346ee&scoped=true&"
import script from "./title-cop.vue?vue&type=script&lang=js&"
export * from "./title-cop.vue?vue&type=script&lang=js&"
import style0 from "./title-cop.vue?vue&type=style&index=0&id=1fc346ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc346ee",
  null
  
)

export default component.exports